export const draft = Object.freeze({
  id: 1,
  name: 'Borrador',
  color: '#B5C3BC',
});

export const completed = Object.freeze({
  id: 2,
  name: 'Completado',
  color: '#5AA9E6',
});

export const submitted = Object.freeze({
  id: 4,
  name: 'Sometido',
  color: '#FAE76F',
});

export const signatureRejected = Object.freeze({
  id: 7,
  name: 'Firma Rechazada',
  color: '#F0AD4E',
});

export const documentCancelled = Object.freeze({
  id: 8,
  name: 'Documento Cancelado',
  color: '#D9534F',
});

export const sent = Object.freeze({
  id: 9,
  name: 'Enviado',
  color: '#2DB782',
});

export const returnedByArv = Object.freeze({
  id: 10,
  name: 'Devuelto por ARV',
  color: '#800020',
});

export const referrallCancelled = Object.freeze({
  id: 11,
  name: 'Cancelado',
  color: '#D9534F',
});

const data = Object.freeze({
  Draft: draft.id,
  Completed: completed.id,
  Submitted: submitted.id,
  SignatureRejected: signatureRejected.id,
  DocumentCancelled: documentCancelled.id,
  Sent: sent.id,
  ReturnedByArv: returnedByArv.id,
  ReferrallCancelled: referrallCancelled.id
});

export default data;
